import { initializeApp } from 'firebase/app';
import { getFirestore } from 'firebase/firestore';
import { getAuth } from 'firebase/auth';
import { getMessaging } from 'firebase/messaging';

const firebaseConfig = {
  apiKey: "AIzaSyBEjYKUdlqKK1pXSIBnHOUwhOr-PQcZka8",
  authDomain: "o-ops-eu.firebaseapp.com",
  projectId: "o-ops-eu",
  storageBucket: "o-ops-eu.firebasestorage.app",
  messagingSenderId: "1027401504433",
  appId: "1:1027401504433:web:adb7df5499c955aa257490"
};

const app = initializeApp(firebaseConfig);

export const db = getFirestore(app);
export const auth = getAuth(app);

export default app;
